var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-message-page',{attrs:{"title":"Questionario inoltrato","message":"Grazie per la collaborazione. ;)"}})}
var staticRenderFns = []

export { render, staticRenderFns }